export default "__VITE_ASSET__CyhEJpN$__"